import PropTypes from "prop-types";
import { Navigate, useSearchParams } from "react-router-dom";
import { LEGACY_TAB_PATHS, SETTINGS_PATHS } from "./settingsPaths";

// The old Settings page URLs now open the modal: /settings opens General and
// /settings?activeTab=Billing (Security, Documents, Support) opens that tab.
export const SettingsRedirect = ({ to }) => {
  const [searchParams] = useSearchParams();
  const target =
    to ||
    LEGACY_TAB_PATHS[searchParams.get("activeTab")] ||
    SETTINGS_PATHS.general;
  return <Navigate to={target} replace />;
};

SettingsRedirect.propTypes = {
  to: PropTypes.string,
};
